import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {LetterPageBO, LetterPageVO} from "@/service/cnipa.s";
import {PatentPageVO, SyncPatentBO, useSyncPatent} from "@/service/patent.s";
import {PaginationCPCVO, PaginationVO} from "@/model/global";
import {useEffect} from "react";
import {get, isEmpty} from "lodash";
import {useGlobalActions} from "@/store/global.c";
import {str2ArrBuff} from "@/helper/method";

export const LetterListPage = () => {
    const [letterPageData, setLetterPageData] = React.useState<PaginationCPCVO<LetterPageVO>>({} as PaginationCPCVO<LetterPageVO>)
    const {setToast} = useGlobalActions()
    const {mutateAsync: syncPatentMutate} = useSyncPatent()

    const columns: GridColDef<LetterPageVO>[] = [
        {field: "cnApplicationnumber", headerName: "申请号", flex: 0.8},
        {
            field: "famingczmc",
            headerName: "发明创作名称",
            headerAlign: "left",
            align: "left",
            flex: 1
        },
        {
            field: "dljgnbbh",
            headerName: "内部编号",
            headerAlign: "left",
            align: "left",
            flex: 0.6,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "tongzhismc",
            headerName: "通知书名称",
            flex: 0.7,
        },
        {
            field: "fawenxlh",
            headerName: "发文序列号",
            flex: 1,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "dianzifwrq",
            headerName: "发文日期",
            headerAlign: "center",
            align: "center",
        },
    ];

    const btnCallback = async ({btn, keys, rows, onSearch}: BtnType<LetterPageVO>) => {
        if (btn.alias == 'sync') {
            if (keys.length > 0 && keys.length <= 30) {
                setToast({message: `开始同步${keys.length}条数据`, open: true, severity: 'success', variant: 'standard', duration: 3})
                window.postMessage({type: "SyncLetter", data: rows})
                return
            } else {
                setToast({message: "请选择一至三十条数据", open: true, severity: 'warning', variant: 'standard'})
            }
        }
    }

    useEffect(() => {
        window.addEventListener("message", listenerMessage)
        return () => window.removeEventListener("message", listenerMessage)
    }, []);


    const listenerMessage = async (event: MessageEvent) => {
        if (event?.data?.type == 'ResultLetterPage') {
            setLetterPageData(event?.data?.data);
        }
        if (event?.data?.type == 'ResultSyncLetter') {
            const letters = event?.data?.data;
            for (const key in letters) {
                const letter: SyncPatentBO = letters[key];
                const formData = new FormData();
                const blob = str2ArrBuff(letter.file)
                const file = new File([blob], `${letter.remark}.zip`, {
                    type: "zip",
                });
                formData.append("file", file);
                formData.append("insideId", letter.insideId);
                formData.append("applyNo", letter.applyNo);
                formData.append("isSave", "1");
                formData.append("tag", "20");
                formData.append("remark", letter.remark);
                formData.append("extra", JSON.stringify(letter.extra));
                await syncPatentMutate({
                    formData, onUploadProgress: (event) => {

                    }
                });
            }
            setToast({message: `同步数据完成`, open: true, severity: 'success', variant: 'standard', duration: 3})
        }
        if (event?.data?.type == 'LoadingComplete') {
            if (isEmpty(letterPageData)) {
                window.postMessage(({
                    type: "QueryLetterPage", data: {
                        reqType: "cn",
                        isDownload: "1",
                    }
                }))
            }
        }
    }

    return (<>
            <ProTable<LetterPageVO>
                loading={false}
                showSearch={false}
                columns={columns}
                btnCallback={btnCallback}
                drawerProps={{
                    view: {
                        viewBtnCallback: (row: PatentPageVO) => {
                            return {businessId: row.id, instanceId: row.instanceId}
                        }
                    }
                }}
                rowId={"fid"}
                data={{...letterPageData, list: letterPageData?.records || []} as PaginationVO<LetterPageVO>}
                onSearch={({reqType, isDownload, postDate, ...rest}: LetterPageBO) => {
                    window.postMessage(({
                        type: "QueryLetterPage", data: {
                            ...rest,
                            reqType: reqType || "cn",
                            isDownload: isDownload || "1",
                            fawenrStart: get(postDate, '[0]', ''),
                            fawenrEnd: get(postDate, '[1]', ''),
                        }
                    }))
                }}
                code={"patent_letter"}
            />
        </>
    );
};
